import React from "react";
import Colors from "../../../../../stories/assets/Colors";
import Fonts from "../../../../../stories/assets/Fonts";
import ModalSkeleton from "../../../../ModalSkeleton/ModalSkeleton";
import ModalSkeletonCssClasses from "../../../../ModalSkeleton/ModalSkeleton.module.css";

import {
    checkCircleGreen,
} from "../../../../../constant/imagePath";
import classes from "./UpdatedModal.module.css";
import { ReactSVG } from "react-svg";

export default function UpdatedModal({ show, setShow }) {
    return (
        <>
            <style>{`
      .${ModalSkeletonCssClasses.body} {
        padding: 20px;
      }
      .${ModalSkeletonCssClasses.iconBox} {
        right: 20px;
      }
          
    `}</style>
            <ModalSkeleton
                show={show}
                setShow={setShow}
                borderRadius={"20px"}
                modalClass={classes.modal}
                width={"376px"}
                showCloseIcon
            >
                <div className={classes.modalContent}>
                    <div className={classes.iconBox}>
                        <ReactSVG src={checkCircleGreen} beforeInjection={(svg) => svg.classList.add(classes.icon)} />
                    </div>
                    <h4
                        style={{
                            ...Fonts.h4f26,
                            color: Colors.neutralShadesOfNero,
                        }}
                    >
                        Updated
                    </h4>
                    <p
                        className={classes.firstLine}
                        style={{
                            ...Fonts.p2,
                            color: Colors.neutralShadesOfDimGray,
                        }}
                    >
                        We’ve updated your feedback and send Jessica the notification!
                    </p>
                </div>
            </ModalSkeleton>
        </>
    );
}
